import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EndpointService } from './endpoint.service';
import { ConsentDTO, ConsentLinksDTO } from '../models/consent';

interface ConsentApiResponse {
  responseObject: ConsentDTO[];
  isSuccess: boolean;
  errors: any[];
}

interface ConsentLinksApiResponse {
  responseObject: ConsentLinksDTO;
  isSuccess: boolean;
  errors: any[];
}

@Injectable({ providedIn: 'root' })
export class ConsentService {

  constructor(private http: HttpClient) {}

  getConsentLinks(): Observable<ConsentLinksDTO> {
    return this.http.get<ConsentLinksApiResponse>(EndpointService.getLatestConsents).pipe(
      map(response => response.responseObject)
    );
  }

  getMissingConsents(userId: string, token: string): Observable<ConsentDTO[]> {
    return this.http.get<ConsentApiResponse>(EndpointService.getMissingConsents(userId), {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    }).pipe(
      map(response => response.responseObject)
    );
  }

  recordConsent(userId: string, token: string, consentIds: number[]): Observable<any> {
    return this.http.post(EndpointService.recordConsent(userId), { consentIds }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
  }
}
